import { useEffect, useState } from "react";
import TimerIcon from "../../assets/icons/timer.svg";
import AbsentIcon from "../../assets/images/shocked_emoji.png";
import StartedIcon from "../../assets/images/fan-star-emoji-orange.png";
import CompletedIcon from "../../assets/images/fan-star-emoji-green.png";
import WeeklyIcon from "../../assets/images/calendar.png";
import SickIcon from "../../assets/images/leave_images/sick_leave.png";
import CasualIcon from "../../assets/images/leave_images/casual_leave.png";
import PrivilegeIcon from "../../assets/images/leave_images/privilage_leave.png";
import MaternityIcon from "../../assets/images/leave_images/maternity : paternity_leave.png";
import MenstrualIcon from "../../assets/images/leave_images/menstrual_leave.png";
import EarnedIcon from "../../assets/images/leave_images/earned_leave.png";
import ESICIcon from "../../assets/images/leave_images/ESIC_leave.png";
import MiscarriageIcon from "../../assets/images/leave_images/miscarriage_leave.png";
import moment from "moment";
import "./AttendanceTimer.css";

const STATUS_CONFIG = {
  not_punched: {
    title: "you’ve not punched in yet",
    subtitle: "Mark your attendance on the mobile app to mark as present.",
    textBg: "#FE9A9A",
    timerBg: "#B11631",
    bg: "#D0213D",
    footer: "Absent",
  },
  half_day: {
    title: "half-day attendance marked",
    subtitle:
      "You clocked in late. Only half-day attendance has been recorded.",
    textBg: "#FFCA7F",
    timerBg: "#B2690E",
    bg: "#D78014",
  },
  started: {
    title: "your shift has started",
    subtitle: "You’ve successfully punched in. Have a great shift today!",
    textBg: "#FD9E83",
    timerBg: "#DA3D09",
    bg: "#FA4B16",
  },
  completed: {
    title: "your shift has completed",
    subtitle: "You’ve completed your shift today. See you tomorrow!",
    textBg: "#56D069",
    timerBg: "#146F27",
    bg: "#008A29",
  },
  leave: {
    title: "you’re on leave today",
    subtitle: "Enjoy your well deserved leave!",
    textBg: "#96A4AE",
    timerBg: "#38444C",
    bg: "#253037",
    footer: "Enjoy!",
  },
  weekend: {
    title: "It’s your weekend today",
    subtitle: "Enjoy your day off!",
    textBg: "#96A4AE",
    timerBg: "#38444C",
    bg: "#253037",
    footer: "Enjoy!",
  },
  compoff: {
    title: "you deserve a comp-off",
    subtitle: "You’re working on a weekend. A comp-off will be credited soon.",
    textBg: "#5EC5FE",
    timerBg: "#054FB5",
    bg: "#0062E2",
  },
};

const AttendanceTimer = ({
  className = "",
  overViewresponse,
  // clockInTime,
  // clockOutTime,
  // shiftHour = 9,
  // leaveType = "",
}) => {
  const { clock_in, clock_out } = overViewresponse?.attendance_details;
  const leaveType = overViewresponse?.attendance_details?.is_on_leave
    ? overViewresponse?.attendance_details?.leave_type
    : "";
  const status = overViewresponse?.status;
  const [timer, setTimer] = useState("00:00:00");
  // const [status, setStatus] = useState();
  let timerId;

  useEffect(() => {
    if (clock_in && !clock_out) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      timerId = setInterval(() => {
        calculateTimeDifference();
      }, 1000);
    } else if (clock_in && clock_out) {
      const caluculateHourDifference = moment
        .utc(
          moment
            .duration(
              moment(
                `${clock_in.split(" ")[0]} ${clock_out}`,
                "YYYY-MM-DD HH:mm:ss",
              ).diff(moment(clock_in, "YYYY-MM-DD HH:mm:ss")),
            )
            .asMilliseconds(),
        )
        .format("HH:mm:ss");
      console.log("caluculateHourDifference", caluculateHourDifference);

      setTimer(`${caluculateHourDifference}`);
    } else {
      setTimer("00:00:00");
      clearInterval(timerId);
    }
    return () => {
      clearInterval(timerId);
    };
  }, [clock_in]);

  // useEffect(() => {
  //   setStatusType();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [clock_in, clock_out]);

  const calculateTimeDifference = () => {
    const checkStartTimeHaveDate = !isNaN(new Date(clock_in));
    // Check hour diffrence between start time date and current date
    const hourDiffrence = moment(new Date()).diff(new Date(clock_in), "hours");
    if ((hourDiffrence > 12 && !clock_out) || !checkStartTimeHaveDate) {
      // logOutUser();
      setTimer("00:00:00");
    } else {
      // Set value for timer in hour ,minutes and seconds
      const timeDiff = moment(new Date()).diff(new Date(clock_in));
      const formattedTime = moment.utc(timeDiff).format("HH:mm:ss").split(":");

      const { hours, minutes, seconds } = {
        hours: formattedTime[0],
        minutes: formattedTime[1],
        seconds: formattedTime[2],
      };
      setTimer(hours + ":" + minutes + ":" + seconds);
    }
  };

  // const setStatusType = () => {
  //   let statustype;
  //   if (clock_in && !clock_out) statustype = "started";
  //   if (clock_in && clock_out) {
  //     const caluculateHourDifference = moment
  //       .utc(
  //         moment(
  //           `${clock_in.split(" ")[0]} ${clock_out}`,
  //           "YYYY-MM-DD HH:mm:ss",
  //         ).diff(moment(clock_in, "YYYY-MM-DD HH:mm:ss")),
  //       )
  //       .format("HH");
  //     if (Number(caluculateHourDifference) < Number(total_work_hours)) {
  //       statustype = "half_day";
  //     } else {
  //       statustype = "completed";
  //     }
  //   }
  //   if (!clock_in && !clock_out) {
  //     statustype = "not_punched";
  //   }
  //   if (leaveType) statustype = "leave";
  //   // setStatus(statustype);
  //   return statustype;
  // };

  const config = STATUS_CONFIG[status] || STATUS_CONFIG.started;
  const showTimer =
    status === "started" ||
    status === "half_day" ||
    status === "completed" ||
    status === "compoff";

  const getLeaveIcon = (type) => {
    switch (type) {
      case "Sick Leave":
      case "SL":
        return SickIcon;
      case "Casual Leave":
      case "CL":
        return CasualIcon;
      case "Privilege Leave":
      case "PL":
        return PrivilegeIcon;
      case "Maternity":
      case "Maternity Leave":
      case "Paternity":
      case "Paternity Leave":
        return MaternityIcon;
      case "Menstrual":
      case "Menstrual Leave":
        return MenstrualIcon;
      case "Miscarriage":
      case "Miscarriage Leave":
        return MiscarriageIcon;
      case "Reserved PL":
      case "RPL":
        return EarnedIcon;
      case "ESIC":
        return ESICIcon;
      default:
        return CasualIcon;
    }
  };

  const getTimerParts = (timeValue) => {
    const [hours = "00", minutes = "00", seconds = "00"] =
      String(timeValue || "00:00:00").split(":");
    return {
      hours: `${hours}h`,
      minutes: `${minutes}m`,
      seconds: `${seconds}s`,
    };
  };

  const timerParts = getTimerParts(timer);

  return (
    <div
      className={`att-timer ${className}`.trim()}
      style={{ backgroundColor: config?.bg }}
    >
      <div className="att-content">
        <div className="flex flex-col timer-txt">
          <div className="timer-head">{config?.title}</div>
          <div className="timer-subhead" style={{ color: config?.textBg }}>
            {config?.subtitle}
          </div>
        </div>
        <img
          className="timer-ico"
          src={
            status === "not_punched" || status === "half_day"
              ? AbsentIcon
              : status === "leave"
                ? getLeaveIcon(leaveType)
                : status === "started"
                  ? StartedIcon
                  : status === "completed"
                    ? CompletedIcon
                    : status === "weekend"
                      ? WeeklyIcon
                      : TimerIcon
          }
          alt=""
        />
      </div>
      <div className="timer-view" style={{ backgroundColor: config?.timerBg }}>
        {showTimer && (
          <div className="timer-view-text timer-view-clock">
            <span>{timerParts.hours}</span>
            <span>{timerParts.minutes}</span>
            <span>{timerParts.seconds}</span>
          </div>
        )}
        {!showTimer && <div className="timer-view-text">{config?.footer}</div>}
      </div>
    </div>
  );
};

export default AttendanceTimer;
